// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { DocumentScope } from '@shared/data-access/types/engine-types';
import { DocumentsPage } from '@shared/document-management';
import { Translation } from '@shared/ui-kit/providers';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { Navigate } from 'react-router';
import { useSilverAlphaProposals } from '../../hooks/use-silver-alpha-proposals';
import styles from './silver-alpha-documents.module.css';

export const useSilverAlphaDocuments = () => {
  const { hasActiveProposal, isLoading } = useSilverAlphaProposals();

  return {
    hasActiveProposal,
    isResolving: isLoading,
  };
};

export const SilverAlphaDocuments = defineComponent({
  displayName: 'SilverAlphaDocuments',
  useSetup: useSilverAlphaDocuments,
  View: ({ hasActiveProposal, isResolving }) => {
    if (isResolving) {
      return null;
    }

    if (!hasActiveProposal) {
      return <Navigate replace to="/silver-alpha" />;
    }

    return (
      <div className={styles.page} data-testid="silver-alpha-documents">
        <header className={styles.header}>
          <p className={styles.eyebrow}>
            <Translation
              i18nKey="silver-alpha-documents.page-eyebrow"
              ns="components"
            />
          </p>
          <h1 className={styles.title}>
            <Translation
              i18nKey="silver-alpha-documents.page-title"
              ns="components"
            />
          </h1>
          <p className={styles.subtitle}>
            <Translation
              i18nKey="silver-alpha-documents.page-subtitle"
              ns="components"
            />
          </p>
        </header>

        <DocumentsPage
          lockedScope={DocumentScope.SilverAlpha}
          embedded
          hideUpload
          hideScopeTabs
        />
      </div>
    );
  },
});
